import { clsx } from 'clsx';
import { ChangeEvent, FocusEvent, forwardRef, MouseEventHandler, useState } from 'react';
import InputMask, { Props } from 'react-input-mask';

import { ClearIcon } from '@/components/icons/input';

import cn from './styles.module.scss';

interface IInput extends Omit<Props, 'mask'> {
    mask?: string;
    label?: string;
    helperText?: string;
    error?: boolean;
    hasClearBtn?: boolean;
    containerClassName?: string;
    onClear?: MouseEventHandler<HTMLButtonElement>;
    formatChars?: Record<string, string>;
}

export const Input = forwardRef<HTMLInputElement, IInput>(
    (
        {
            mask = '',
            label,
            helperText,
            error = false,
            onClear,
            hasClearBtn = true,
            containerClassName,
            ...props
        },
        ref
    ) => {
        const [value, setValue] = useState<string>();
        const [focused, setFocused] = useState(false);

        const handleFocus = (event: FocusEvent<HTMLInputElement>) => {
            setFocused(true);
            if (props.onFocus) props.onFocus(event);
        };
        const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
            setFocused((props.value ? props.value : value) !== undefined && mask === '');
            if (props.onBlur) props.onBlur(event);
        };
        const handleChange = (event: ChangeEvent<HTMLInputElement>) => setValue(event.target.value);
        const handleClear: MouseEventHandler<HTMLButtonElement> = e => {
            e.preventDefault();
            setValue('');
        };

        const hasVal = (props.value ? props.value : value) !== undefined || focused;

        return (
            <div className={clsx(cn.inputContainer, containerClassName)}>
                <div className={clsx(cn.inputWrapper, error && cn.error)}>
                    <InputMask
                        mask={mask}
                        id="input"
                        type="text"
                        value={value}
                        {...props}
                        onChange={e => {
                            const { value } = e.target;
                            e.target.value = value.startsWith(' ') ? value.replace(' ', '') : value;

                            if (props.onChange) {
                                props.onChange(e);
                            } else {
                                handleChange(e);
                            }
                        }}
                        inputRef={ref} // передавать ref через ф-ю, например: ref={(el) => ref.current = el}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                    />
                    <label className={clsx(hasVal && cn.shifted)} htmlFor="input">
                        {label}
                    </label>
                    {hasClearBtn && hasVal && (
                        <button
                            className={cn.clearButton}
                            onClick={onClear ? onClear : handleClear}
                        >
                            {ClearIcon}
                        </button>
                    )}
                </div>
                {helperText && (
                    <p className={clsx(cn.helperText, error && cn.errorText)}>{helperText}</p>
                )}
            </div>
        );
    }
);
